import { useState } from 'react'
import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const ProjectTypeSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.projectType || translations.de.projectType
  const [showAndere, setShowAndere] = useState(formData.projekt_typ === 'andere')

  const handleProjectTypeChange = (value) => {
    updateFormData('projekt_typ', value)
    setShowAndere(value === 'andere')
    if (value !== 'andere') {
      updateFormData('projekt_typ_andere', '')
    }
  }

  return (
    <FormSection title={t.title}>
      <h3 className="form-section__subtitle">{t.subtitle1}</h3>
      
      <div className="radio-group">
        <label className="radio-group__option">
          <input
            type="radio"
            name="projekt_typ"
            value="neue-website"
            checked={formData.projekt_typ === 'neue-website'}
            onChange={(e) => handleProjectTypeChange(e.target.value)}
          />
          <span className="radio-group__label">{t.neue_website}</span>
        </label>

        <label className="radio-group__option">
          <input
            type="radio"
            name="projekt_typ"
            value="relaunch"
            checked={formData.projekt_typ === 'relaunch'}
            onChange={(e) => handleProjectTypeChange(e.target.value)}
          />
          <span className="radio-group__label">{t.relaunch}</span>
        </label>

        <label className="radio-group__option">
          <input
            type="radio"
            name="projekt_typ"
            value="redesign"
            checked={formData.projekt_typ === 'redesign'}
            onChange={(e) => handleProjectTypeChange(e.target.value)}
          />
          <span className="radio-group__label">{t.redesign}</span>
        </label>

        <label className="radio-group__option">
          <input
            type="radio"
            name="projekt_typ"
            value="erweiterung"
            checked={formData.projekt_typ === 'erweiterung'}
            onChange={(e) => handleProjectTypeChange(e.target.value)}
          />
          <span className="radio-group__label">{t.erweiterung}</span>
        </label>

        <label className="radio-group__option">
          <input
            type="radio"
            name="projekt_typ"
            value="andere"
            checked={formData.projekt_typ === 'andere'}
            onChange={(e) => handleProjectTypeChange(e.target.value)}
          />
          <span className="radio-group__label">{t.andere}</span>
        </label>
      </div>

      {showAndere && (
        <div className="form-group">
          <input
            type="text"
            id="projekt_typ_andere"
            name="projekt_typ_andere"
            className="form-group__input"
            placeholder={t.andere_placeholder}
            value={formData.projekt_typ_andere || ''}
            onChange={(e) => updateFormData('projekt_typ_andere', e.target.value)}
          />
        </div>
      )}

      <h3 className="form-section__subtitle">{t.subtitle2}</h3>

      <div className="form-group">
        <label htmlFor="projekt_beschreibung" className="form-group__label">
          {t.beschreibung}
        </label>
        <textarea
          id="projekt_beschreibung"
          name="projekt_beschreibung"
          className="form-group__input form-group__textarea"
          placeholder={t.beschreibungPlaceholder}
          value={formData.projekt_beschreibung || ''}
          onChange={(e) => updateFormData('projekt_beschreibung', e.target.value)}
          required
        />
      </div>
    </FormSection>
  )
}

export default ProjectTypeSection
